import { berthApiClient } from '../berthApiClient'

import { getUserFeaturesEndpoint } from './endpoint'
import type { GetUserFeaturesResponse } from './type'

// サイドメニューの表示制御は Redux/saga 経由のため、useQuery ではなく callable 関数で提供する。
export const getUserFeatures = async (): Promise<GetUserFeaturesResponse> => {
  const res = await berthApiClient.get<GetUserFeaturesResponse>(getUserFeaturesEndpoint)
  return res.data
}
